// removed by extract-text-webpack-plugin
module.exports = {"versionComponent":"Version__versionComponent","title":"Version__title","version":"Version__version","hidden":"Version__hidden","growDotQello":"Version__growDotQello","growDotBlue":"Version__growDotBlue","growDotGolden":"Version__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Version/Version.scss
// module id = 1925
// module chunks = 0